module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header-top-c"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, _vm._l((_vm.$route.matched), function(m) {
    return _c('li', {
      key: m.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: m.path
        }
      }
    }, [_vm._v(_vm._s(m.meta.title) + " > ")])], 1)
  })), _vm._v(" "), (_vm.$route.meta.title) ? _c('span', {
    staticClass: "page-title"
  }, [_vm._v(" " + _vm._s(_vm.$route.meta.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sysContent"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db542074","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Content.vue
// module id = 1282
// module chunks = 2